var _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse2, _rect11, _rect12, _rect13, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHealthPilatesServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 136,
    viewBox: "0 0 162 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.502,
    y: 48.4326,
    width: 99.9036,
    height: 21.0323,
    rx: 10.5162,
    fill: "#EEC2B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1543,
    y: 61.6553,
    width: 98.3201,
    height: 29.3899,
    rx: 14.695,
    transform: "rotate(-35 12.1543 61.6553)",
    fill: "#EEC2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.502,
    y: 69.4639,
    width: 115.678,
    height: 21.0323,
    rx: 10.5162,
    fill: "#EEC2B9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.502,
    y: 90.4971,
    width: 105.162,
    height: 21.0323,
    rx: 10.5162,
    fill: "#EEC2B9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.502,
    y: 111.529,
    width: 94.6455,
    height: 21.0323,
    rx: 10.5162,
    fill: "#EEC2B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.0178,
    cy: 87.8675,
    rx: 42.0647,
    ry: 44.6937,
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 43.1709,
    width: 99.9036,
    height: 21.0323,
    rx: 10.5162,
    fill: "#FFDCD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1543,
    y: 56.3936,
    width: 98.3201,
    height: 29.3899,
    rx: 14.695,
    transform: "rotate(-35 12.1543 56.3936)",
    fill: "#FFDCD5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 64.2021,
    width: 115.678,
    height: 21.0323,
    rx: 10.5162,
    fill: "#FFDCD5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 85.2354,
    width: 105.162,
    height: 21.0323,
    rx: 10.5162,
    fill: "#FFDCD5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 106.268,
    width: 94.6455,
    height: 21.0323,
    rx: 10.5162,
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.0178,
    cy: 82.6058,
    rx: 42.0647,
    ry: 44.6937,
    fill: "#FFDCD5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8242,
    y: 37.9121,
    width: 105.177,
    height: 62.3272,
    fill: "#00C968"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8242,
    y: 37.9697,
    width: 35.0591,
    height: 62.3272,
    fill: "#A4EECB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8594,
    y: 45.7607,
    width: 62.3272,
    height: 46.7454,
    fill: "#A4EECB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4247 90.6904L65.0997 81.7268H62.1305V79.3458H64.4835L62.1586 70.4102H65.1558L67.2846 79.3458H70.8701L73.111 70.4102H76.1922L78.4331 79.3458H82.0186L84.1474 70.4102H87.1447L84.8197 79.3458H87.1727V81.7268H84.2035L81.8505 90.6904H78.7693L76.4443 81.7268H72.8589L70.5339 90.6904H67.4247ZM67.8729 81.7268L68.9373 86.2366H69.1334L70.2818 81.7268H67.8729ZM73.5031 79.3458H75.8281L74.7356 75.1722H74.5676L73.5031 79.3458ZM79.0494 81.7268L80.1698 86.2646H80.3379L81.4303 81.7268H79.0494Z",
    fill: "#00C968"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealthPilatesServiceBody);
export default __webpack_public_path__ + "static/media/IcHealthPilatesServiceBody.58152a3f5ec642ff2997bafa9c7a0132.svg";
export { ForwardRef as ReactComponent };